import React from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@contently/toolkit';
import TitleCell from './TitleCell';
import RegularCell from './RegularCell';
import ContentSpendCell from './ContentSpendCell';
import TrafficValueCell from './TrafficValueCell';
import PillarCell from './PillarCell';
import { getRegionalInfo, regionalTrafficValAvg } from './utils';

function TableWrapper({ region, tableInfo, trafficValAvg }) {
  const defaultColumns = [
    {
      Header: 'Title',
      accessor: 'title',
      minWidth: 350,
      Cell: TitleCell
    },
    {
      Header: 'Pillar',
      accessor: 'content_pillar',
      Cell: PillarCell
    },
    {
      Header: 'Spend',
      accessor: 'content_spend',
      Cell: ContentSpendCell
    },
    {
      Header: 'SEO Traffic',
      accessor: `${getRegionalInfo(region)}_traffic`,
      Cell: RegularCell
    },
    {
      Header: 'SEO Traffic Value',
      accessor: `${getRegionalInfo(region)}_traffic_value`,
      Cell: props => (
        <TrafficValueCell
          data={props}
          trafficValAvg={regionalTrafficValAvg(region, trafficValAvg)}
        />
      )
    }
  ];
  const pageSize = 10;
  return (
    <DataTable.Table
      data={tableInfo}
      columns={defaultColumns}
      pageSize={pageSize}
      pageCount={Math.ceil(tableInfo.length/pageSize)}
      showTotal={false}
      defaultSortBy={[{ id: `${getRegionalInfo(region)}_traffic_value`, desc: true }]}
      errorMessage="No data is available yet - please add published URLs in order to see the content value of your stories next month."
    />
  );
}

export default TableWrapper;

TableWrapper.propTypes = {
  tableInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      pillar: PropTypes.string,
      totalContentDebit: PropTypes.string,
      totalOrganicSearchTraffic: PropTypes.number,
      totalOrganicSearchTrafficValue: PropTypes.string
    })
  ).isRequired,
  trafficValAvg: PropTypes.shape({
    avg_all_traffic: PropTypes.number,
    avg_canada_traffic: PropTypes.number,
    avg_us_traffic: PropTypes.number
  }).isRequired,
  region: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/table_wrapper.jsx